'use strict';

const $ = require('jquery');
const Slide = require('./slide');
const lang = require('../lang');
const template = require('../templates/scan-driver-license-slide.hbs');
const {isEmpty} = require('lodash');

module.exports = class extends Slide {
  constructor(context = {}) {
    super(template, context);
    this.domEvents = {
      'click #rescan': '_rescan',
    };
    this._timer = 8;
    this._timerID = null;
    this._idletimer = _idletimer;
    this.on('beforeEnter', this._loadImage);
    this.on('beforeEnter', this._restartVideo);
    this.on('afterLeave', this.reset);
    this.on('afterEnter', this._stopIdleTimer);
    this.countervar = 1;
  }

  reset() {
    // Clear name buttons on leave
    let btn_container = document.getElementById("btn-container");
    while (btn_container.firstChild) {
      btn_container.removeChild(btn_container.firstChild);
    }
    // Clear images of scanned ID cards on leave
    let img_container = document.getElementById("img-container");
    while (img_container.firstChild) {
      img_container.removeChild(img_container.firstChild);
    }
    // Stop count-down on leave
    clearInterval(this._intervalHandler);
    clearTimeout(this._timerID);
  }

  _loadImage() {
    localStorage.removeItem("idscan_id");
    localStorage.removeItem("idscan_approve_status");
    $('#scan-driver-license-slide-text').show();
    $('#id-card-insert').show();
    $('#idle-camera-image').hide();
    $('#scan-driver-license-wait-text').hide();
    $("#scan_err_msg").html('');
    $("#rescan").hide();
    $("#driver-license-slide-next-button").hide();
    $("#scan-driver-license-empty-text").hide();
    if (typeof this._slideshow._location.module_manual_entry !== 'undefined' && this._slideshow._location.module_manual_entry !== 1) {
      $("#scan-driver-license-empty-text").show();
    }
    let countdown = this._timer;
    this._intervalHandler = setInterval(() => {
      countdown -= 1;
      if (countdown === 0) {
        $('#idle-camera-image').show();
        $('#scan-driver-license-wait-text').show();
        $('#scan-driver-license-slide-text').hide();
        $('#id-card-insert').hide();
        $('#scan-driver-license-empty-text').hide();
        this._getIdScans();
      }
    }, 1000);
  }


  _getIdScans() {
    const scannerID = localStorage.getItem("scannerID") || "";
    $("#scan-driver-license-empty-text").hide();

    if (typeof this._slideshow._location.module_manual_entry !== 'undefined' && this._slideshow._location.module_manual_entry === 1) {
      $("#driver-license-slide-next-button").show();
    }
    $.ajax({
      method: 'POST', url: '/getIdScans', data: {
        locationId: this._slideshow._location.id, userlang: lang.locale, scannerid: scannerID,
      }
    }).done((scanned) => {
      // If no scanned IDs, keep polling
      if (isEmpty(scanned)) {
        this._timerID = setTimeout(() => {
          this._getIdScans();
        }, 3000);
      } else {
        // if scanned IDs, and idscannerid is not empty, then click on the scanned ID
        if (scannerID !== '' && scannerID !== 'undefined') {
          if (scanned[0]['source_result'] !== '' && scanned[0]['source_result'] !== 1) {
            localStorage.setItem("idscan_approve_status", 0);
            localStorage.setItem("idscan_id", scanned[0].id);
          }
          $('#form_field_id_scan').val(scanned[0].id);
          $('#form_field_name').val(scanned[0].FirstName + ' ' + scanned[0].LastName);
          var index = this._slideshow.findIndex(require('./form-slide'));
          window.location.hash = '#/' + index;
          _updateIdScans(scanned[0].id);
        }
        // manual entry allowed
        if (typeof this._slideshow._location.module_manual_entry !== 'undefined' && this._slideshow._location.module_manual_entry === 1) {
          $("#driver-license-slide-next-button").show();
        }

        for (let i = 0; i < scanned.length; i++) {
          let name = scanned[i].FirstName + ' ' + scanned[i].LastName;
          let dataName = name;
          if (name === ' ') {
            name = '---';
            dataName = '';
          }
          $('#idle-camera-image').hide();
          $('#driver-license-slide-next-button').hide();
          if ($('#' + scanned[i].id)[0] === undefined) {
            if (scanned[i].source_result !== '' && scanned[i].source_result !== 1 && typeof this._slideshow._location.module_manual_entry !== 'undefined' && this._slideshow._location.module_manual_entry !== 1) {
              $('#btn-container').append("<li id=" + scanned[i].id + "><a onClick='_updateIDScanAddCheck(" + scanned[i].id + ");' href='#/" + this._slideshow.findIndex(require('./form-slide')) + "' data-name='" + dataName + "'>" + name + '</a></li>');
            } else {
              $('#btn-container').append("<li id=" + scanned[i].id + "><a onClick='_updateIdScans(" + scanned[i].id + ");' href='#/" + this._slideshow.findIndex(require('./form-slide')) + "' data-name='" + dataName + "'>" + name + '</a></li>');
            }
          }
          $("[data-name]").click(function () {
            $('#form_field_name').val($(this).attr("data-name"));
            $('#form_field_id_scan').val(scanned[i].id);
          });
        }
      }
    }).fail((payload) => {
      console.error('Something went wrong: ', payload);
    });
  }


  // SLIDE EVENTS
  _setChoiceListClass() {
    const $choiceList = $('.choice-list');
    $choiceList.removeClass('choice-list--two-columns choice-list--three-columns');
    if (this._tracks.length > 8) $choiceList.addClass('choice-list--three-columns'); else if (this._tracks.length > 4) $choiceList.addClass('choice-list--two-columns');
  }

  _restartVideo() {
    $('#driver-license-slide-next-button').hide();
    let video = document.getElementById('id-card-insert');
    video.pause();
    video.currentTime = 0;
    video.load();
  }

  _stopIdleTimer() {
    if (_idleintervalHandler != undefined) {
      clearInterval(_idleintervalHandler);
    }
  }


  _rescan() {
    $("#scan_err_msg").html('');
    $("#rescan").hide();
    this._restartVideo();
    this._loadImage();
  }


};